import { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";

import request from "../../../utilities/requests";

const Notebook = ({ open, close, eventId }) => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (eventId) {
      getNotebook();
    }
  }, [eventId]);

  const getNotebook = async () => {
    setLoading(true);
    const result = await request(`pairing/notebook?eventId=${eventId}`);
    if (result.success) {
      setNotes(result.notes);
    }
    setLoading(false);
  };

  const renderNotes = () => {
    if (loading) {
      return (
        <div style={{ display: "flex", justifyContent: 'center' }}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <DialogContent
        style={{ display: "flex", flexDirection: "column", gap: 10 }}
      >
        {notes.map((note, index) => {
          return (
            <div key={index}>
              <Typography>
                <span style={{ fontWeight: "bold" }}>Round:</span> {note?.round}
              </Typography>
              <Typography>
                <span style={{ fontWeight: "bold" }}>Name: </span> {note?.name}
              </Typography>
              <Typography>
                <span style={{ fontWeight: "bold" }}>Note: </span> {note?.text}
              </Typography>
              {index < notes.length - 1 && (
                <Divider style={{ marginTop: 10 }} />
              )}
            </div>
          );
        })}
      </DialogContent>
    );
  };

  return (
    <Dialog open={open} onClose={() => close()} fullWidth>
      <DialogTitle>Event Notebook</DialogTitle>
      {renderNotes()}
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Notebook;
